import { axiosApi } from "../../../api/dbAxios";

export const fetchData = async (
  currentPage: number,
  filters: any = {},
  use_ids: { code: string; case_no: string }[] = [],
  isFavoriteTypeList: boolean = false,
) => {
  try {
    if ("use_ids" in filters && currentPage === 0) delete filters.use_ids;

    const postData: any = {
      ...filters,
      ...(use_ids && use_ids.length > 0 && currentPage !== 0
        ? { use_ids }
        : {}),
      ...(isFavoriteTypeList ? { only_favorite: true } : {}),
      limit: 70,
      offset: currentPage * 70,
    };

    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (
        (Array.isArray(value) && value.length === 0) ||
        value === null ||
        value === "" ||
        typeof value === "undefined"
      ) {
        delete postData[key];
      }
    });

    const response = await axiosApi.post(`/items/`, postData);

    return response.data;
  } catch (error) {
    console.error("Error fetching item list:", error);
    return [];
  }
};
